// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"bdd2bf51","314":"25a4304c","405":"c208c416","442":"c208c416","454":"cfb7af7d","486":"c208c416","508":"37bdef6e","811":"69714590","814":"767fc031"}[chunkId] + ".css";
};